import { render, staticRenderFns } from "./adminDocuments.vue?vue&type=template&id=4977e140&"
import script from "./adminDocuments.vue?vue&type=script&lang=js&"
export * from "./adminDocuments.vue?vue&type=script&lang=js&"
import style0 from "./adminDocuments.vue?vue&type=style&index=0&id=4977e140&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports